export default {"src":"/login-app/[GIT_HASH]/_next/static/media/priority_6.b0722b9b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};